<template>
  <div class="content">
    <mu-card class="bottom">
      <mu-card-text v-if="data !== false" style="padding: 8px;">

        <mu-row style="align-items: center">
          <mu-col width="40" desktop="40" tablet="40">
            <div class="blueText cardTitle">{{$t('message.foodDiary' + type.charAt(0).toUpperCase() + type.slice(1))}}
            </div>
          </mu-col>
          <mu-col width="60" desktop="60" tablet="60" align="right">

            <mu-icon-button
              v-tooltip.left="'Favourite'"
              iconClass="redIcon"
              v-if="data"
              @click.native="favorite(data.id)"
              :icon="data.userFavorites  ? 'favorite' : 'favorite_outline'">
            </mu-icon-button>

            <mu-icon-button
              v-tooltip.left="'View breakdown'"
              v-if="data"
              @click.native="isGraphShown = !isGraphShown"
              icon="bar_chart">
            </mu-icon-button>

            <mu-icon-button
              v-tooltip.left="'Refresh'"
              v-if="!readonly"
              @click.native="refresh"
              icon="refresh">
            </mu-icon-button>


            <mu-icon-button
              v-tooltip.left="'View recipe'"
              @click.native="goTo(data.id)"
              icon="chevron_right">
            </mu-icon-button>

          </mu-col>
        </mu-row>
        <mu-row gutter style="align-items:center">
          <mu-col v-if="data" class="recipeBg" width="30" tablet="25" desktop="25"
                  :style="{'background': 'url(' + data.photoSmallUri + ')'}"
                  style="display: flex; justify-content: center">


            <mu-circular-progress
              v-if="isLoading"
              style="display: flex; align-self:center"
              color="white">
            </mu-circular-progress>

          </mu-col>
          <mu-col width="70" tablet="75" desktop="75" v-if="data">
            <div class="blueText" style="font-size: 16px;">
              {{data.title}}
            </div>
            <div>
              {{data.servings}} serving(s) &middot; Carbs {{oneCarbPortion.toFixed(0)}}g (1 serving)
            </div>
          </mu-col>
        </mu-row>
      </mu-card-text>
      <mu-card-text v-if="isLoading && data === false" style="padding: 8px;">


        <mu-row style="align-items: center">
          <mu-col width="50" desktop="50" tablet="50">
            <div class="blueText cardTitle">{{$t('message.foodDiary' + type.charAt(0).toUpperCase() + type.slice(1))}}
            </div>
          </mu-col>
          <mu-col width="50" desktop="50" tablet="50" align="right">
            <mu-icon-button
              :disabled="true"
              iconClass="redIcon"
              :icon="'favorite_outline'">
            </mu-icon-button>

            <mu-icon-button
              :disabled="true"
              icon="bar_chart">
            </mu-icon-button>

            <mu-icon-button
              :disabled="true"
              icon="refresh">
            </mu-icon-button>

          </mu-col>
        </mu-row>
        <mu-row gutter style="align-items:center">
          <mu-col
            class="recipeBg"
            width="30"
            :style="{'background': 'url(static/recipe-placeholder.png)'}"
            tablet="25"
            desktop="25"
            style="display: flex; justify-content: center">
          </mu-col>
          <mu-col width="70" tablet="75" desktop="75">
            <div class="blueText" style="font-size: 16px;">
              <mu-linear-progress
                slot="describe" color="#d9d9d9"
                style="width: 50%; height: 14px;background: rgb(214, 214, 214); margin-bottom: 8px"
                v-bind:style="{width: getRandomArbitrary(40, 90)}"
              ></mu-linear-progress>
            </div>
            <div>
              <mu-linear-progress
                slot="describe" color="#d9d9d9"
                style="width: 50%; height: 14px;background: rgb(214, 214, 214); margin-bottom: 8px"
                v-bind:style="{width: getRandomArbitrary(40, 50)}"
              ></mu-linear-progress>
            </div>
          </mu-col>
        </mu-row>
      </mu-card-text>


      <mu-card-text v-if="data && isGraphShown" class="bubble-progress">


        <div
          style="overflow: hidden; white-space: nowrap; font-size: 0; -webkit-border-radius: 8px;-moz-border-radius: 8px;border-radius: 8px;margin-bottom: 16px">
          <span class="inline-block-bar"
                :style="{'width': nutrientPercentage.fat + '%', 'background': 'rgb(192, 77, 216)'}"></span>
          <span class="inline-block-bar"
                :style="{'width': nutrientPercentage.carbs + '%', 'background': 'rgb(78, 216, 218)'}"></span>
          <span class="inline-block-bar"
                :style="{'width': nutrientPercentage.protein + '%', 'background': 'rgb(224, 105, 80)'}"></span>
        </div>

        <span class="outer-bubble"><span class="bubble" style="background-color: rgb(192, 77, 216)"></span>
          {{$t('message.nutrientFat')}}: {{oneFatPortion.toFixed(0) + 'g'}}
        </span>
        <span class="outer-bubble">
          <span class="bubble" style="background-color:rgb(78, 216, 218)"></span>
          {{$t('message.nutrientCarbohydrateShort')}}: {{oneCarbPortion.toFixed(0) + 'g'}}</span>
        <span class="outer-bubble">
          <span class="bubble" style="background-color: rgb(224, 105, 80)"></span>
          {{$t('message.nutrientProtein')}}: {{oneProteinPortion.toFixed(0) + 'g'}}</span>


      </mu-card-text>

    </mu-card>
  </div>
</template>

<script>

  import RecipeApi from '../../../../api/Recipes'
  import MuIconButton from "muse-ui/src/iconButton/iconButton";
  import MuCircularProgress from "muse-ui/src/circularProgress/circularProgress";
  import MuLinearProgress from "muse-ui/src/linearProgress/linearProgress";


  export default {
    components: {
      MuLinearProgress,
      MuCircularProgress,
      MuIconButton
    },
    name: "meal-plan-panel",
    props: {
      type: {
        type: String,
        default: 'breakfast'
      },
      activeDay: {
        type: String,
        default: 'MONDAY'
      },
      recipe: {
        type: Array,
        default: []
      },
      dietaryTypes: {
        type: String,
        default: ''
      },
      allergies: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      filters: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        isGraphShown: false,
        isLoading: true,
        data: false
      }
    },
    watch: {
      'recipe': function () {
        if (this.recipe.length > 0) {
          this.isLoading = false;
          this.data = this.recipe[0];
          this.$forceUpdate();

        }
        else {

          this.isLoading = true;
          this.data = this.recipe[0];
          this.$emit('changed', this.data);
        }

      },
      'activeDay': function () {
        if (this.recipe.length > 0) {
          this.isLoading = false;
          this.data = this.recipe[0];
          this.$emit('changed', this.data);
        }
        else {
          this.refresh();
        }
      }
    },
    mounted() {
      let self = this;
      if (self.readonly === true) {
        self.data = self.recipe[0];
        self.isLoading = false;

      }
      else {
        self.isLoading = true;

      }
    },
    methods: {
      getRandomArbitrary(min, max) {
        return Math.floor(Math.random() * (max - min) + min) + '%'
      },
      favorite(id) {
        let self = this;
        RecipeApi.favorite(id)
          .then(function (response) {
            self.data.userFavorites = response.data.favorite;
            self.$forceUpdate();
          })
      },
      goTo(id) {
        let url = this.$router.resolve({
          name: 'RecipeDetail',
          params: {
            id: id
          }
        });
        window.open(url.href, '_blank');
      },
      refresh() {
        let self = this;
        self.isLoading = true;

        let searchObject = {
          categories: self.type,
          dietaryTypes: self.dietaryTypes,
          suitabilities: self.allergies,
          servingslte: self.data.servings,
          limit: 1,
          shuffle: true
        };

        let filter = JSON.parse(JSON.stringify(self.filters));
        let searchObj = Object.assign(filter, searchObject);


        RecipeApi.search(searchObj)
          .then(function (response) {
            self.isLoading = false;
            self.data = response.data.recipes[0];
            self.$emit('changed', self.data);
          })
      }
    },

    computed: {
      nutrientPercentage() {
        let self = this;
        let total = (self.oneCarbPortion + self.oneFatPortion + self.oneProteinPortion);
        return {
          carbs: ((self.oneCarbPortion / total) * 100),
          fat: ((self.oneFatPortion / total) * 100),
          protein: ((self.oneProteinPortion / total) * 100)
        };
      },
      oneProteinPortion() {
        let self = this;
        let carbValue = self.data.nutrition.protein.val, servings = self.data.servings;
        return carbValue * (1 / servings)
      },
      oneFatPortion() {
        let self = this;
        let carbValue = self.data.nutrition.fat.val, servings = self.data.servings;
        return carbValue * (1 / servings)
      },

      oneCarbPortion() {
        let self = this;
        let carbValue = self.data.nutrition.carbohydrate.val, servings = self.data.servings;
        return carbValue * (1 / servings)
      }
    }
  }
</script>
<style lang="less">
  .bubble-progress {
    span.outer-bubble {
      margin-right: 8px;
    }
    .bubble {
      width: 12px;
      height: 12px;
      display: inline-block;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      margin-right: 4px;
    }
  }

  .inline-block-bar {
    height: 22px;
    display: inline-block;
  }

  .redIcon {
    color: red;
  }

  .recipeBg {
    background-position: center center !important;
    background-size: cover !important;
    background-repeat: no-repeat no-repeat !important;
    height: 110px;
  }

  .cardTitle {
    font-size: 18px;
    margin-top: -8px;
  }

  .blueText {
    color: #3279cf;
  }
</style>



// WEBPACK FOOTER //
// meal-plan-panel.vue?6ffff875